module.exports = __webpack_public_path__ + "static/img/1-1.82a6f03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/1-1.png
// module id = xCLE
// module chunks = 0